import { render, staticRenderFns } from "./SelectLanguageModal.vue?vue&type=template&id=6d5f86ce&"
import script from "./SelectLanguageModal.vue?vue&type=script&lang=js&"
export * from "./SelectLanguageModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectLanguageModal.vue?vue&type=style&index=0&id=6d5f86ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports